import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import insertInArrayIf from '@zola-helpers/client/dist/es/util/insertInArrayIf';
import getRegistryShopLinks from 'components/nav/data/registryShopLinks';
import experimentFlags, { HOLIDAY_SHOPS } from 'util/experimentFlags';
import type { MobileNavLink } from '../MobileNavMenuData';

const getContextDependentLinks = (userContext: UserContext): MobileNavLink[] => {
  const isGuest = userContext.is_guest;
  const registryActivated = userContext.has_registry;

  const preAuthLinks = [
    {
      title: 'Start Your Registry',
      path: '/onboard/new',
    },
    {
      title: 'About Registry',
      path: '/wedding-registry',
    },
  ];

  const inactiveRegistryLinks = [
    {
      title: 'Start Your Registry',
      path: '/onboard/new',
    },
    {
      title: 'Registry Checklist',
      path: '/registry/landing/checklist',
    },
  ];

  const activeRegistryLinks = [
    {
      title: 'Manage Registry',
      path: '/my-registry',
    },
    {
      title: 'Registry Checklist',
      path: '/registry/landing/checklist',
    },
    {
      title: 'Gift Tracker',
      path: '/registry/gift-tracker',
    },
  ];

  if (isGuest) {
    return preAuthLinks;
  }
  if (registryActivated) {
    return activeRegistryLinks;
  }
  return inactiveRegistryLinks;
};

const cashFundLinks: MobileNavLink[] = [
  { title: 'Experiences', path: '/shop/category/experiences' },
  { title: 'Cash Funds', path: '/shop/honeymoon-cash-funds' },
  {
    title: 'Add from another store',
    path: '/wedding-registry/add-from-other-stores',
  },
];

const aboutRegistryLinks: MobileNavLink[] = [
  { title: 'About Registry ', path: 'https://www.zola.com/wedding-registry' },
  {
    title: 'Registry FAQs',
    path: '/faq/category/115000342372-registry',
  },
];
export default function getMobileRegistryMenuData(userContext: UserContext): MobileNavLink[][] {
  const isShopHolidaySeason = experimentFlags.getFlag(HOLIDAY_SHOPS, userContext);
  return [
    getContextDependentLinks(userContext),
    getRegistryShopLinks(isShopHolidaySeason, true),
    cashFundLinks,
    ...insertInArrayIf(!userContext.is_guest, aboutRegistryLinks),
  ];
}
